import { useState, useEffect } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { AccessTime } from '@mui/icons-material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import { Grid, Box, MenuItem } from '@mui/material';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import RowContentPre from './components/RowContentPrewrap';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const OpContent = (props: Props) => {
  const { disabled, register, watch, setValue, getValues } = props;

  const [methodEtc, setMethodEtc] = useState(0);

  const method_labels = ['Local', 'General', 'Spinal', 'Epidural'];
  const timePickers = [
    { title: 'Giờ bệnh nhân tới', variable: 'surgery_details.arrival_time' },
    {
      title: 'Bắt đầu gây mê',
      variable: 'surgery_details.anesthesia_start_time',
    },
    {
      title: 'Bắt dầu\nphẫu thuật',
      variable: 'surgery_details.surgery_start_time',
    },
    {
      title: 'Kết thúc\nphẫu thuật',
      variable: 'surgery_details.surgery_end_time',
    },
    {
      title: 'Kết thúc gây mê',
      variable: 'surgery_details.anesthesia_end_time',
    },
    {
      title: 'Bệnh nhân\nra ngoài',
      variable: 'surgery_details.discharge_time',
    },
  ];

  useEffect(() => {
    if (
      ![...method_labels, undefined].includes(
        getValues('surgery_details.anesthetic_method')
      )
    ) {
      setValue(
        'surgery_details.anesthetic_method_etc',
        getValues('surgery_details.anesthetic_method')
      );
      setMethodEtc(1);
    }
  }, []);

  return (
    <>
      <SectionTitle title="Chi tiết" />
      <RowContainer xs={12}>
        <Grid item xs={12}>
          <Form.MuiTextField
            multiline
            minRows={15}
            disabled={disabled}
            required={false}
            {...register('surgery_details.content')}
          />
        </Grid>
        {timePickers.map(({ title, variable }, i) => {
          if (i === 2 || i === 3 || i === 5) {
            return (
              <RowContentPre
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2}
              >
                <MobileTimePicker
                  disabled={disabled}
                  value={watch(variable) || null}
                  onChange={value => setValue(variable, value)}
                  renderInput={params => (
                    <MuiTextField
                      {...params}
                      required={false}
                      placeholder="00:00"
                      InputProps={{ endAdornment: <AccessTime /> }}
                    />
                  )}
                />
              </RowContentPre>
            );
          }
          return (
            <RowContent
              key={variable}
              title={title}
              titleRatio={1}
              childrenRatio={2}
            >
              <MobileTimePicker
                disabled={disabled}
                value={watch(variable) || null}
                onChange={value => setValue(variable, value)}
                renderInput={params => (
                  <MuiTextField
                    {...params}
                    required={false}
                    placeholder="00:00"
                    InputProps={{ endAdornment: <AccessTime /> }}
                  />
                )}
              />
            </RowContent>
          );
        })}
        <RowContentPre
          title="Phương pháp
gây mê"
          titleRatio={1}
          childrenRatio={2}
        >
          <MuiTextField
            {...register('surgery_details.anesthetic_method')}
            required={false}
            disabled={disabled}
          />
        </RowContentPre>
        <RowContent title="Bác sĩ gây mê" titleRatio={1} childrenRatio={2}>
          <MuiTextField
            {...register('surgery_details.anesthesiologist')}
            required={false}
            disabled={disabled}
          />
        </RowContent>
      </RowContainer>
    </>
  );
};

export default OpContent;
